<template>
  <div v-if="planner != null && user != null && ($store.state.user.id == planner.user_id || $store.state.user.role == 1)">

    <PageHeader v-bind:label="isUserThisPlanner ? 'My Details' : planner.first_name + ' ' + planner.last_name + ' Details'"></PageHeader>

    <div class="my-8">

      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
          <InputText
            label="First name"
            propertyKey="firstName"
            objectType="user"
            v-bind:value="user.firstName"
            v-bind:updateValue="updateValue"></InputText>
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputText
            label="Last name"
            propertyKey="lastName"
            objectType="user"
            v-bind:value="user.lastName"
            v-bind:updateValue="updateValue"></InputText>
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputText
            label="Company name"
            propertyKey="company"
            objectType="planner"
            v-bind:value="planner.company"
            v-bind:updateValue="updateValue"></InputText>
        </div>
      </div>

      <div class="flex flex-wrap label-line">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
          <InputText
            label="Website"
            propertyKey="url"
            objectType="planner"
            v-bind:value="planner.url"
            v-bind:updateValue="updateValue"></InputText>
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputText
            label="AFSL Number"
            propertyKey="afsl_number"
            objectType="planner"
            v-bind:value="planner.afsl_number"
            v-bind:updateValue="updateValue"></InputText>

          <div v-if="afslError != null" class="mt-2 text-red-500 text-sm">{{ afslError }}</div>
        </div>

        <!-- <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">

        </div> -->
      </div>

      <div class="mt-12 font-thin text-gray-700 text-2xl">
        Contacts
      </div>

      <div class="flex flex-wrap mt-4">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
          <InputPhone
            label="Mobile phone"
            propertyKey="phone_mobile"
            objectType="planner"
            v-bind:value="planner.phone_mobile"
            v-bind:updateValue="updateValue"></InputPhone>
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputPhone
            label="Office phone"
            propertyKey="phone_office"
            objectType="planner"
            v-bind:value="planner.phone_office"
            v-bind:updateValue="updateValue"></InputPhone>
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputText
            label="Email"
            propertyKey="email"
            objectType="user"
            v-bind:value="user.email"
            v-bind:updateValue="updateValue"></InputText>
        </div>
      </div>

      <div class="mt-12 font-thin text-gray-700 text-2xl">
        Address
      </div>

      <div class="flex flex-wrap mt-4">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
          <InputText
            label="Address line 1"
            propertyKey="address1"
            objectType="planner"
            v-bind:value="planner.address1"
            v-bind:updateValue="updateValue"></InputText>
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputText
            label="Address line 2"
            propertyKey="address2"
            objectType="planner"
            v-bind:value="planner.address2"
            v-bind:updateValue="updateValue"></InputText>
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputText
            label="City"
            propertyKey="city"
            objectType="planner"
            v-bind:value="planner.city"
            v-bind:updateValue="updateValue"></InputText>
        </div>
      </div>

      <div class="flex flex-wrap label-line">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
          <InputText
            label="Postcode"
            propertyKey="postcode"
            objectType="planner"
            v-bind:value="planner.postcode"
            v-bind:updateValue="updateValue"></InputText>
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
          <StateSelector
            propertyKey="state_id"
            objectType="planner"
            v-bind:value="planner.state_id"
            v-bind:updateValue="updateValue"></StateSelector>
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <CountrySelector
            propertyKey="country_id"
            objectType="planner"
            v-bind:value="planner.country_id"
            v-bind:updateValue="updateValue"></CountrySelector>
        </div>
      </div>
    </div>
    <AutoSaveLoader v-bind:autoSaving="autoSaving"></AutoSaveLoader>
  </div>
</template>

<script>

  import axios            from "axios"
  import StateSelector    from '@/shared/components/form/StateSelector'
  import InputText        from '@/shared/components/form/InputText'
  import InputPhone       from '@/shared/components/form/InputPhone'
  import CountrySelector  from '@/shared/components/form/CountrySelector'
  import PageHeader       from '@/shared/components/headers/PageHeader'
  import { EventBus }     from '@/shared/event-bus';
  import AutoSaveLoader   from '@/shared/components/loaders/AutoSaveLoader'

  export default {

    components: {
      StateSelector,
      InputText,
      InputPhone,
      CountrySelector,
      PageHeader,
      AutoSaveLoader
    },

    data() {
      return {
        loading   : false,
        autoSaving: false,
        planner   : null,
        user      : null,
        afslError  : null
      }
    },

    created() {
      this.prepare();
    },

    mounted() {
      EventBus.$on('set-autosave', trueOrFalse => {
        this.autoSaving = trueOrFalse
      });
    },

    destroyed() {
      EventBus.$off('set-autosave')
    },

    methods : {    

      prepare() {
        if (this.isUserAdmin()) {
          this.apiGet({
            plannerId : this.$route.params.plannerId
          }, 'planner/detail', (planner) => {
            this.planner = planner;

            this.apiGet({
              userId : planner.user_id
            }, 'planner/user/detail', (user) => {
              this.hideLoader();
              this.user = user
            })
          })
        }
      },

      updateValue(params) {
        if(params.objectType == 'user') {
          this.updatePlannerUser(this.user, params.key, params.value)
        }

        else if(params.objectType == 'planner') {

          if(params.key == 'afsl_number') {
            if(params.value.length > 0 && params.value.length != 6) {
              this.afslError = 'AFLS number should be 6 digits'
            } else {
              this.afslError = null
              this.updatePlanner(this.planner, params.key, params.value)
            }
          }

          else {
            this.updatePlanner(this.planner, params.key, params.value)
          }
        }
      },
    },
  }
</script>
